import * as React from "react";
import { Menu, Dropdown } from "antd";
import { ChevronDown } from "lucide-react";
import { Icon } from "src/components/icons/Icon";

import { Link, NavLink } from "react-router-dom";

interface IProps {
	title: string;
}

const NavAntDropdown = (props: IProps) => {
	const antMenu = (
		<Menu>
			<Menu.Item key="0">
				{/* TODO: create admin role page first */}
				<NavLink
					className="nav-link ant-nav-link"
					to="/admin/organizations/1/roles"
				>
					<span>Admin Roles</span>
				</NavLink>
			</Menu.Item>
			<Menu.Item key="1">
				<NavLink className="nav-link ant-nav-link" to="/admin/organizations/1">
					<span>Default Organization</span>
				</NavLink>
			</Menu.Item>
			<Menu.Item key="2">
				<NavLink className="nav-link ant-nav-link" to="/admin/users">
					<span>User Manager</span>
				</NavLink>
			</Menu.Item>
			<Menu.Item key="3">
				<NavLink className="nav-link ant-nav-link" to="/admin/training">
					<span>Training Manager</span>
				</NavLink>
			</Menu.Item>
		</Menu>
	);

	return (
		<Dropdown overlay={antMenu}>
			<a className="nav-link">
				{props.title}
				<Icon icon={ChevronDown} className="nav-icon" />
			</a>
		</Dropdown>
	);
};

export default NavAntDropdown;
